export default __webpack_public_path__ + "static/media/contact.67800f92.png";